export type CheckoutStep =
  | 'billingPlan'
  | 'account'
  | 'whoIsThisFor'
  | 'athleteInformation'
  | 'agreementWaiver'
  | 'payment';

export const CHECKOUT_STEP_ORDER: CheckoutStep[] = [
  'billingPlan',
  'account',
  'whoIsThisFor',
  'athleteInformation',
  'agreementWaiver',
  'payment',
];

export const CHECKOUT_STEP_LABELS: Record<CheckoutStep, string> = {
  billingPlan: 'Billing Plan',
  account: 'Your Account',
  whoIsThisFor: 'Who Is This For?',
  athleteInformation: 'Athlete Information',
  agreementWaiver: 'Agreement & Waiver',
  payment: 'Payment',
};

// The checkout page renders one of four mutually exclusive phases: the accordion
// itself, the post-purchase confirmation (whose content variant comes from the
// checkout response — a full class is a confirmation variant, not an error), the
// class-reservation dead end for hard reservation failures, or the
// billing-plan-disabled error screen a mid-checkout disable fails forward into.
export type CheckoutPhase = 'checkout' | 'confirmation' | 'kiloClassError' | 'billingPlanError';

export default CheckoutStep;
